import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { QrObraAdminStatusService } from '../services/qr-obra-admin-status-service';


@Injectable({
  providedIn: 'root'
})
export class QrObraAdminStatusResolver implements Resolve<boolean> {

  constructor(private service: QrObraAdminStatusService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}